import { render, staticRenderFns } from "./CloneTask.vue?vue&type=template&id=9cf7486a&"
import script from "./CloneTask.vue?vue&type=script&lang=js&"
export * from "./CloneTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports